import styled from "styled-components";

const Box = styled.div({
  alignItems: "flex-start",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: 8,
});

export default Box;
